import { LibConfig } from "../../init";
export const getLeaguesRequest = () => {
    return {
        ids: LibConfig.sportIds,
        // pagination: START_PAGINATION,
        includeRegions: true
    };
};
//# sourceMappingURL=getLeaguesRequest.js.map